// extracted by mini-css-extract-plugin
export default {"root":"_3nl1G","avatar":"_37nkD"};